import React from 'react'
import PropTypes from 'prop-types'

import { StyledList, StyledListItem } from 'components/product/styled';

function List({ listItems, shouldShowAllItem }) {

  return (
    <StyledList>
      {listItems.map(el => {
        return (
          <StyledListItem 
            featuredItem={el.featured} 
            shouldShowAllItem={shouldShowAllItem}
            className={el.featured ? "featured-list-item" : "not-featured-list-item"}
          >
            <span>
              <img src="https://images.prismic.io/privatefly/5e231ef5-4344-48db-8c26-878215f331f5_Arrow-Right.png?auto=compress,format" />
            </span> 
            {el.list_item}
          </StyledListItem>
        )
      })
    }  
    </StyledList>
  )
}

List.propTypes = {
  listItems: PropTypes.array,
  shouldShowAllItem: PropTypes.bool,
}

export default List

